import { render, staticRenderFns } from "./ResetPasswordCustomer.vue?vue&type=template&id=40568b68&"
import script from "./ResetPasswordCustomer.vue?vue&type=script&lang=js&"
export * from "./ResetPasswordCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports